import { create } from 'zustand';

interface InterfaceState {
    loading: boolean;
    error: string | null;
    syncing: boolean;
    fetchDataStart: () => void;
    fetchDataSuccess: () => void;
    fetchDataFailure: (error: string) => void;
    syncStart: () => void;
    syncEnd: () => void;
}

export const useInterfaceStore = create<InterfaceState>((set) => ({
    loading: false,
    error: null,
    syncing: false,
    fetchDataStart: () => set({ loading: true, error: null }),
    fetchDataSuccess: () => set({ loading: false, error: null }),
    fetchDataFailure: (error) => set({ loading: false, error }),
    syncStart: () => set({ syncing: true }),
    syncEnd: () => set({ syncing: false }),
}));

export const useInterface = () => ({
    loading: useInterfaceStore((state) => state.loading),
    syncing: useInterfaceStore((state) => state.syncing),
});
